// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-collapse/~/rc-animate/lib/index.js
 ** module id = 450
 ** module chunks = 0
 **/